import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SiderContextType {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  toggleCollapsed: () => void;
}

const SiderContext = createContext<SiderContextType | undefined>(undefined);

export const useSider = () => {
  const context = useContext(SiderContext);
  if (context === undefined) {
    throw new Error('useSider must be used within a SiderProvider');
  }
  return context;
};

interface SiderProviderProps {
  children: ReactNode;
}

export const SiderProvider: React.FC<SiderProviderProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const value: SiderContextType = {
    collapsed,
    setCollapsed,
    toggleCollapsed,
  };

  return (
    <SiderContext.Provider value={value}>
      {children}
    </SiderContext.Provider>
  );
}; 